import { IDataType, ISerializeContext } from '@ecp-caf/common-structure';
import { DtoStructureReferType } from '../../define/data-type/structure-refer-type';
import { RefTypeEnum } from '../../define/ref-type-enum';

export class StructureReferTypeConvertor{

    convertToObject(obj:Object,datatype:IDataType,ctxt:ISerializeContext):void{
        var referType=datatype as DtoStructureReferType;
        obj["kind"]=referType.getKind();
        obj['referId']=referType.referId;
        obj['referType']=referType.referType;
    }

    initFromObject(dataType:IDataType,obj:Object,ctxt:ISerializeContext):void{
        var refType=dataType as DtoStructureReferType;
        refType.kind=obj['kind'];
        refType.referId=obj['referId'];
        refType.referType=obj['referType'] as RefTypeEnum; 
    }
}